"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_BUILD_SESSION = "UPDATE_BUILD_SESSION";
exports.ON_CONFLICT = "ON_CONFLICT";
exports.CLEAR_CONFLICT = "CLEAR_CONFLICT";
exports.ON_ATTACH_CHOICE = "ON_ATTACH_CHOICE";
exports.ON_SHORT_CODE = "ON_SHORT_CODE";
exports.CLEAR_ATTACH_CHOICE = "CLEAR_ATTACH_CHOICE";
exports.UPDATE_FINANCE_SETTINGS = "UPDATE_FINANCE_SETTINGS";
exports.SET_SCREENSHOT_COUNT = "SET_SCREENSHOT_COUNT";
exports.ADD_SCREENSHOT = "ADD_SCREENSHOT";
exports.DELETE_SCREENSHOT = "DELETE_SCREENSHOT";
exports.RESTORE_SCREENSHOT = "RESTORE_SCREENSHOT";
exports.UPDATE_TOAST_QUEUE = "UPDATE_TOAST_QUEUE";
exports.ADD_TOAST = "ADD_TOAST";
exports.CLEAR_TOAST_QUEUE = "CLEAR_TOAST_QUEUE";
exports.UPDATE_ENVIRONMENTS = "UPDATE_ENVIRONMENTS";
exports.UPDATE_ENVIRONMENT = "UPDATE_ENVIRONMENT";
exports.UPDATE_THUMBS = "UPDATE_THUMBS";
exports.UPDATE_STREAMING_ENVIRONMENT = "UPDATE_STREAMING_ENVIRONMENT";
exports.SET_ALL_CODES = "SET_ALL_CODES";
exports.UPDATE_MODE = "UPDATE_MODE";
//# sourceMappingURL=ActionTypes.js.map